import React from "react";
import { IconButton } from "@/components/Button/Button";
import iconInfo from "@/assets/icons/iconInfo.svg";
import s from "./WidgetHeader.module.css";
import containerStyles from "../WidgetContainer/WidgetContainer.module.css";

const WidgetHeader = ({ title, onInfoClick, isInfoOpen, children }) => {
  return (
    <div className={`${containerStyles.header} ${s.header}`}>
      <h1 className={containerStyles.title}>{title}</h1>
      <IconButton icon={iconInfo} alt="info" onClick={onInfoClick} />
      {isInfoOpen && children}
    </div>
  );
};

export default WidgetHeader;
